import { Center, Input } from '@chakra-ui/react';

const FiltrosClientes = ({ setFiltros }) => {
	return (
		<Center>
			<Input
				borderColor='blue.200'
				rounded='none'
				placeholder='Buscar...'
				name='busqueda'
				onChange={setFiltros}
			/>
		</Center>
	);
};

export default FiltrosClientes;
